import {
    Box,
    Button,
    CardContent,
    FormControlLabel,
    Switch,
    TextField,
    Typography
} from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import api from '../../../services/api';
import React, { Component } from 'react';
import { validateField } from 'lib/functions';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class OpcionalVeiculoForm extends Component {
    state = {
        isNewRecord: false,
        isView: false,
        opcionalveiculo: {
            codopcionalveiculo: '',
            descopcionalveiculo: '',
            inativoopc: ANAO
        },
        openAlert: false,
        messageAlert: '',
        errors: {},
        schema: {
            descopcionalveiculo: {
                presence: { allowEmpty: false, message: 'Descrição do opcional obrigatória' },
                length: { maximum: 64 },
                type: 'string'
            }
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        const { id } = this.props.match.params;
        const { location } = this.props;

        try {
            if (!isNaN(Number(id))) {
                await this.loadOpcionaisVeiculo(id, location.pathname.includes('/view'));
            } else if (id === 'novo') {
                this.setState({
                    isNewRecord: true,
                    isView: false,
                    opcionalveiculo: this.getOpcionalVeiculoDefault()
                });
            }
        } catch (error) {
            console.error('Erro ao carregar opcional de veículo:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao carregar opcional de veículo!'
            );
        }
    };

    /* Retorna o opcional de veículo padrão */
    getOpcionalVeiculoDefault = () => ({
        codopcionalveiculo: '',
        descopcionalveiculo: '',
        inativoopc: ANAO
    });

    /* Carrega os opcionais de veículo */
    loadOpcionaisVeiculo = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/opcionalveiculo/${id}`);
        const registro = response?.data?.data?.[0];

        if (!registro) {
            this.handleOpenAlert('Opcional de veículo não encontrado!');

            history.push('/frotas/opcionalveiculo');

            return;
        }

        this.setState({
            opcionalveiculo: {
                codopcionalveiculo: registro.codopcionalveiculo || '',
                descopcionalveiculo: registro.descopcionalveiculo || '',
                inativoopc: registro.inativoopc || ANAO
            },
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, type, value, checked } = event.target;

        let adjustedValue =
            type === 'checkbox' ? (checked ? ANAO : ASIM) :
                type === 'radio' ? Number(value) : value.toUpperCase();

        this.setState(prevState => ({
            opcionalveiculo: {
                ...prevState.opcionalveiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de opcional de veículo */
    getPayloadOpcionalVeiculo = () => {
        const { opcionalveiculo } = this.state;

        return {
            descopcionalveiculo: opcionalveiculo.descopcionalveiculo || '',
            inativoopc: opcionalveiculo.inativoopc || ANAO
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { opcionalveiculo, isNewRecord } = this.state;
        const { history, loadOpcionaisVeiculo } = this.props;

        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        try {
            const payload = this.getPayloadOpcionalVeiculo();

            if (isNewRecord) {
                await api.post('/opcionalveiculo', payload);
            } else {
                await api.put(`/opcionalveiculo/${opcionalveiculo.codopcionalveiculo}`, payload);
            }

            if (loadOpcionaisVeiculo) loadOpcionaisVeiculo();

            history.push('/frotas/opcionalveiculo');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao salvar!'
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/opcionalveiculo');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { opcionalveiculo, schema } = this.state;
        let errors = {};

        // valida os campos do schema
        const requiredFields = [
            'descopcionalveiculo'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, opcionalveiculo[field], schema);

            if (error) {
                errors[field] = error;
            }
        });

        return errors;
    };

    render() {
        const {
            errors,
            isView,
            messageAlert,
            opcionalveiculo,
            openAlert
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Opcional de veículos {opcionalveiculo.codopcionalveiculo}
                        </Typography>

                        <FormControlLabel
                            label={(opcionalveiculo.inativoopc === ASIM) ? 'Inativo' : 'Ativo'}
                            control={
                                <Switch
                                    checked={!(opcionalveiculo.inativoopc === ASIM)}
                                    name="inativoopc"
                                    onChange={this.onChange}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <br />

                    <Box>
                        <TextField
                            label="Descrição"
                            name="descopcionalveiculo"
                            value={opcionalveiculo.descopcionalveiculo || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.descopcionalveiculo || ''}
                            error={!!errors.descopcionalveiculo}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            style={{ minWidth: 300 }}
                        />
                    </Box>

                    <br />
                    <br />

                    <Box
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 10
                        }}
                    >
                        <Button
                            name="salvar"
                            color="primary"
                            variant="contained"
                            onClick={this.onClickSave}
                            disabled={isView}
                        >
                            Salvar
                        </Button>

                        <Button
                            name="cancelar"
                            variant="contained"
                            onClick={this.onClickCancel}
                            color="secondary"
                        >
                            Cancelar
                        </Button>
                    </Box>
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default OpcionalVeiculoForm;